import { VOLKSWAGEN_THEME_ID, FID_THEME_ID } from '@/utils/config'

import fidLogoImage from '@/assets/fid-logo.svg'
import logoImageWithName from '@/assets/logo-name.svg'
import logoImage from '@/assets/logo-sm.svg'
import vwLogoImage from '@/assets/vw-logo.svg'

import fid from './fid'
import renting from './renting'
import vw from './vw'

const brandsThemeMap = {
  renting,
  vw,
  fid,
}

export const getBrandTheme = (brandId) => {
  return brandsThemeMap[brandId?.toLowerCase()] || null
}

export const getBrandLogo = (brandId, withCompanyName) => {
  switch (brandId?.toLowerCase()) {
    case VOLKSWAGEN_THEME_ID:
      return vwLogoImage
    case FID_THEME_ID:
      return fidLogoImage
    default:
      return withCompanyName ? logoImageWithName : logoImage
  }
}

export default brandsThemeMap
